var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.06 15.75v-1.5c0-.796-.317-1.559-.881-2.121a3.012 3.012 0 0 0-2.127-.879H6.036c-.798 0-1.563.316-2.128.879a2.996 2.996 0 0 0-.88 2.121v1.5M9.044 8.25a3.004 3.004 0 0 0 3.008-3c0-1.657-1.346-3-3.008-3a3.004 3.004 0 0 0-3.008 3c0 1.657 1.347 3 3.008 3Z",
  stroke: "#FA530A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export { SvgIconUser as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-user.02f5ae71.svg";